'use client';

import { cn } from '@/lib/utils';
import { useTranslation } from '@/lib/i18n';

export interface EmptyStateProps {
  /** 标题（i18n key），默认 'No Active Strategies' */
  title?: string;
  /** 描述（i18n key），传空字符串可隐藏 */
  description?: string;
  className?: string;
}

/**
 * 空状态：插图 + 标题 + 描述（Figma 706-6238 节点 Frame / 提示）。
 * 插图为 Figma 导出的 150×150 SVG（/image/empty-strategies.svg）。
 */
export function Empty({
  title = 'No Active Data',
  description = 'There is no data to show you right now',
  className,
}: EmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex flex-col items-center', className)}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/image/empty-strategies.svg" alt="" className="size-37.5" aria-hidden="true" />
      <h3 className="mt-4 text-sm font-semibold leading-3 text-white">{t(title)}</h3>
      {description && (
        <p className="mt-4 max-w-61.75 text-center text-xs leading-4 text-[#757575]">
          {t(description)}
        </p>
      )}
    </div>
  );
}

export default Empty;
